'use client';

import { useEffect } from 'react';
import ErrorLayout from '../shared/pageComponents/error-layout';
import { GlobalLoading } from '@/shared/components';

export default function Error() {
  useEffect(() => {
    GlobalLoading.hide();
  }, []);

  return (
    <ErrorLayout
      title="System Error"
      description="Unexpected issue occurred, please try again in some time or contact customer service "
    />
  );
}
